class AccessoryPDP {
  constructor() {
    this.initMainProductSwiper();
  }

  initMainProductSwiper() {
    this.thumbsSwiper = new Swiper('.ProdSwiperThumbs', {
      slidesPerView: 4.5,
      spaceBetween: 20,
      threshold: 10,
      roundLengths: true,
      breakpoints: {
        767: {
          slidesPerView: 4.5,
          spaceBetween: 20,
        },
        1025: {
          slidesPerView: 5,
          spaceBetween: 44,
        },
      },
    });

    this.swiper = new Swiper('.MPCMainSlider.swiper-container', {
      slidesPerView: 1,
      threshold: 10,
      roundLengths: true,
      pagination: {
        el: '.MPCMainSlider__Pagination',
        type: 'bullets',
        clickable: true,
      },
      thumbs: {
        swiper: this.thumbsSwiper,
      },
      breakpoints: {},
    });
  }
}

new AccessoryPDP();
